export const DraftsTab = () => {
  return (
    <p>DraftsTab</p>
  )
}